export const portalDe = {

  // ── Onboarding survey (/portal/onboarding) ───────────────────────────────
  onboarding: {
    title: "Willkommen — wie können wir Ihnen helfen?",
    subtitle: "Sagen Sie uns, was Sie hierher führt, damit wir Sie an die richtige Stelle leiten können.",
    later: "Ich erledige das später",
    back: "Zurück",
    choices: {
      applyTitle: "Thailand Elite beantragen : Thailand Privilege Visum",
      applyDesc: "Starten Sie Ihren Mitgliedschafts- / Langzeitvisum-Antrag.",
      memberTitle: "Ich bin bereits Thailand-Elite-Mitglied",
      memberDesc: "Verknüpfen Sie Ihre Mitgliedschaft oder fordern Sie Mitgliederservices an.",
      prospectTitle: "Ich habe Fragen, bevor ich mich entscheide",
      prospectDesc: "Erhalten Sie Informationen und sprechen Sie mit einem Berater.",
      partnerTitle: "Ich vertrete eine Agentur oder einen Partner",
      partnerDesc: "Entdecken Sie Partnerschafts- und Empfehlungsoptionen.",
      otherTitle: "Etwas anderes",
      otherDesc: "Eine andere Anfrage — sagen Sie uns, wie wir helfen können.",
      servicesTitle: "Immobilien, Versicherung & weitere Services",
      servicesDesc: "Immobilien, Versicherung, ein anderes Visum oder Hilfe beim Ankommen in Thailand.",
    },
    applicant: {
      heading: "Ein paar kurze Fragen",
      subtitle: "Das hilft uns, Ihren Antrag anzupassen. Sie können es später ändern.",
      purposeLabel: "Was ist Ihr Hauptgrund für Thailand Elite?",
      timelineLabel: "Wann möchten Sie den Antrag stellen oder umziehen?",
      submit: "Weiter zu meinem Antrag",
    },
    purpose: {
      retirement: "Ruhestand / Langzeitaufenthalt",
      business: "Geschäft / Arbeit",
      family: "Familie / Angehörige",
      investment: "Investition",
      lifestyle: "Lebensstil / häufiges Reisen",
      other: "Sonstiges",
    },
    timeline: {
      asap: "So bald wie möglich",
      m1_3: "Innerhalb von 1–3 Monaten",
      m3_6: "In 3–6 Monaten",
      m6_12: "In 6–12 Monaten",
      exploring: "Ich informiere mich nur",
    },
    member: {
      heading: "Willkommen zurück — finden wir Ihre Mitgliedschaft",
      subtitle: "Geben Sie Ihre Mitgliedsnummer an, und unser Team verknüpft sie nach einer kurzen Prüfung mit diesem Konto.",
      idLabel: "Mitglieds- / Kartennummer",
      idPlaceholder: "z. B. TPC123456",
      sinceLabel: "Seit wann sind Sie Mitglied?",
      sincePlaceholder: "z. B. 2022",
      viaLabel: "Wie haben Sie den Antrag gestellt?",
      viaPlaceholder: "Agent, direkt usw.",
      helpLabel: "Wie können wir helfen?",
      helpPlaceholder: "Beschreiben Sie Ihr Anliegen (Visumeintrag, 90-Tage-Meldung, Verlängerung…).",
      submit: "Absenden",
    },
    inquiry: {
      heading: "Erzählen Sie uns etwas mehr",
      subtitle: "Wir leiten Ihre Anfrage an die richtige Person weiter und melden uns.",
      typeLabel: "Worum geht es bei Ihrer Anfrage?",
      messageLabel: "Ihre Nachricht",
      messagePlaceholder: "Sagen Sie uns, wie wir Ihnen helfen können.",
      submit: "Anfrage senden",
    },
    inquiryTypes: {
      general_inquiry: "Allgemeine Frage",
      member_service: "Bestehendes Mitglied — Serviceanfrage",
      partnership: "Agentur / Partnerschaft",
      visa_other: "Andere Visa- / Einwanderungsfrage",
      other_services: "Immobilien, Versicherung oder andere Services",
      other: "Sonstiges",
    },
    services: {
      heading: "Wobei können wir Ihnen helfen?",
      subtitle: "Wählen Sie alles aus, was Sie interessiert — wir bringen Sie mit dem passenden Partner zusammen.",
      interestsLabel: "Ich interessiere mich für",
      messageLabel: "Möchten Sie etwas ergänzen?",
      messagePlaceholder: "z. B. Suche nach einer Wohnung in Bangkok, Krankenversicherung für zwei…",
      submit: "Senden",
      needInterestTitle: "Bitte mindestens eine Option wählen",
      needInterestDesc: "Sagen Sie uns, was Sie interessiert.",
    },
    interests: {
      real_estate: "Immobilien",
      insurance: "Kranken- / Reiseversicherung",
      other_visa: "Ein anderes Visum",
      business_setup: "Firmengründung",
      relocation: "Umzugshilfe (Schulen, Bank…)",
      extraLabel: "Können wir Ihnen in Thailand noch bei etwas anderem helfen?",
    },
    deleteAccount: {
      link: "Konto versehentlich erstellt? Jetzt löschen",
      title: "Konto löschen?",
      desc: "Ihr Konto und die eingegebenen Daten werden dauerhaft gelöscht. Dies kann nicht rückgängig gemacht werden.",
      confirm: "Mein Konto löschen",
      cancel: "Abbrechen",
      doneTitle: "Konto gelöscht",
      doneDesc: "Ihr Konto wurde gelöscht. Sie sind jederzeit wieder willkommen.",
      failedTitle: "Konto konnte nicht gelöscht werden",
      notEligible: "Dieses Konto hat einen Antrag oder eine Mitgliedschaft. Schreiben Sie uns, und wir schließen es für Sie.",
    },
    done: {
      title: "Ihre Anfrage wurde übermittelt",
      desc: "Vielen Dank — unser Team prüft sie und meldet sich in Kürze bei Ihnen.",
      cta: "Zu meinem Dashboard",
    },
    optionalTag: "(optional)",
    memberOutcome: {
      linkedTitle: "Mitgliedschaft verknüpft ✓",
      linkedDesc: "Willkommen zurück — Ihr Mitgliederbereich ist bereit.",
      pendingTitle: "Fast geschafft — bestätigen Sie Ihre Mitgliedschaft",
      pendingDesc: "Wir haben eine Bestätigung an Ihre hinterlegte E-Mail-Adresse ({{email}}) gesendet. Sobald Sie bestätigen und unser Team es freigibt, wird Ihre Mitgliedschaft verknüpft.",
    },
    banner: {
      memberTitle: "Danke — wir überprüfen Ihre Mitgliedschaft",
      memberDesc: "Unser Team verknüpft Ihre Mitgliedsnummer in Kürze mit diesem Konto. Sie werden benachrichtigt, sobald es bestätigt ist.",
      prospectTitle: "Danke für Ihre Kontaktaufnahme",
      prospectDesc: "Ein Berater meldet sich mit den gewünschten Informationen. Bereit für einen Antrag? Sie können unten jederzeit beginnen.",
      partnerTitle: "Danke für Ihr Interesse an einer Partnerschaft",
      partnerDesc: "Bereit für eine Partnerschaft? Reichen Sie Ihr Firmenprofil ein, um zu beginnen — oder unser Partnerschaftsteam meldet sich bei Ihnen.",
      partnerCta: "Partner werden",
      otherTitle: "Ihre Anfrage ist eingegangen",
      otherDesc: "Unser Team prüft sie und meldet sich in Kürze bei Ihnen.",
    },
    toast: {
      saveFailedTitle: "Speichern nicht möglich",
      saveFailedDesc: "Bitte versuchen Sie es erneut.",
      applicantOkTitle: "Großartig — los geht's",
      applicantOkDesc: "Sie können jetzt mit Ihrem Antrag beginnen.",
      needMessageTitle: "Bitte fügen Sie eine kurze Nachricht hinzu",
      needMessageDesc: "Sagen Sie uns, wie wir helfen können.",
    },
  },
  common: {
    saveAndContinue: "Speichern & weiter",
    back: "Zurück",
    submit: "Antrag einreichen",
    submitting: "Wird eingereicht…",
    saving: "Wird gespeichert…",
    uploading: "Wird hochgeladen…",
    required: "Pflichtfeld",
    optional: "optional",
    yes: "Ja",
    no: "Nein",
    select: "Auswählen…",
    uploaded: "Hochgeladen",
    missing: "Fehlt",
    loading: "Wird geladen…",
    download: "Herunterladen",
    upload: "Hochladen",
    remove: "Entfernen",
    retry: "Erneut versuchen",
    next: "Weiter",
    close: "Schließen",
    addDocuments: "Dokumente hinzufügen",
    signOut: "Abmelden",
    memberPortal: "Mitgliederportal",
    language: "Sprache",
    // Toast messages
    fileTooLarge: "Datei zu groß",
    maxSizeAllowed: "Maximal {{size}} erlaubt.",
    uploadFailed: "Upload fehlgeschlagen",
    invalidEmail: "Ungültige E-Mail",
  },

  dashboard: {
    nextMemberApp: "Angehörigen-Antrag",
    addNextMember: "Angehörigen hinzufügen",
    nextMemberPromo: "Aktion: 750.000 THB pro Angehörigem bis 31.12.2026",
    myApplications: "Meine Anträge",
    noApplications: "Noch keine Anträge",
    noApplicationsDesc: "Starten Sie Ihre Thailand Elite-Reise, indem Sie Ihren ersten Antrag erstellen.",
    createApplication: "Antrag erstellen",
    newApplication: "Neuer Antrag",
    resumeApplication: "Antrag fortsetzen",
    alreadyActiveTitle: "Antrag bereits in Bearbeitung",
    alreadyActiveDesc: "Sie haben bereits einen aktiven Antrag. Bitte schließen oder stornieren Sie diesen, bevor Sie einen neuen erstellen.",
    package: "Programm",
    created: "Erstellt",
    messages: "Nachrichten",
    newThread: "Neuer Thread",
    newThreadSubject: "Betreff",
    newThreadBody: "Nachricht",
    generalInquiry: "Allgemeine Anfrage",
    noMessages: "Noch keine Nachrichten",
    status: {
      open: "Offen",
      waiting_reply: "Antwort ausstehend",
      closed: "Geschlossen",
      draft: "Entwurf",
      submitted: "Eingereicht",
      under_review: "In Prüfung",
      background_check: "Hintergrundprüfung",
      approved: "Genehmigt",
      payment_pending: "Zahlung ausstehend",
      payment_done: "Warten auf Aktivierung",
      active: "Aktiv",
      cancelled: "Storniert",
      rejected: "Abgelehnt",
    },
  },

  // ── Member Area ──────────────────────────────────────────────────────────
  membership: {
    card: {
      sectionTitle: "Ihre Mitgliedskarte",
      tierLabel:    "Mitgliedschaft",
      holderLabel:  "Karteninhaber",
      numberLabel:  "Kartennummer",
      validFrom:    "Gültig ab",
      validUntil:   "Gültig bis",
      printOrSave:  "Drucken oder als PDF speichern",
    },
    documents: {
      lettersTitle:                "Offizielle Schreiben",
      welcomeLetter:               "Willkommensschreiben",
      welcomeLetterDesc:           "Ihr offizielles Thailand Elite Willkommensschreiben",
      welcomeLetterPending:        "Wird nach Bestätigung der Aktivierung von Ihrem Agenten hochgeladen",
      certificationLetter:        "Zertifizierungsschreiben",
      certificationLetterDesc:    "Offizielles Thailand Privilege Zertifizierungsdokument",
      certificationLetterPending: "Verfügbar, sobald es von Thailand Privilege ausgestellt wurde",
      pending:                    "Ausstehend",
    },
  },

  // ── Member Services / Service Requests ───────────────────────────────────
  services: {
    tabLabel:           "Services",
    title:              "Mitgliederservices",
    intro:              "Reichen Sie eine Serviceanfrage ein — Visa-Anbringung, 90-Tage-Meldung oder ein anderes Anliegen. Ihre Mitgliedsnummer wird automatisch angehängt.",
    chooseType:         "Service auswählen",
    noTypes:            "Derzeit sind keine Servicearten verfügbar. Bitte wenden Sie sich an den Support.",
    estimated:          "~{{days}} Werktage",
    history:            "Ihre bisherigen Anfragen",
    back:               "Zurück zu den Services",
    requirementsTitle:  "Was Sie bereitstellen müssen",
    memberIdLabel:      "Eingereicht als",
    subject:            "Betreff",
    messageLabel:       "Beschreiben Sie Ihr Anliegen",
    messagePlaceholder: "Geben Sie alle Details an, die uns helfen, Ihre Anfrage schneller zu bearbeiten.",
    attachments:        "Anhänge",
    addFile:            "Zum Hochladen klicken (PDF / JPG / PNG, max. 10 MB)",
    send:               "Anfrage senden",
    submittedTitle:     "Anfrage übermittelt",
    submittedDesc:      "Unser Mitgliederservice-Team prüft Ihre Anfrage und antwortet über Nachrichten.",
    submittedDescMcc:      "Unser Team prüft sie und antwortet über Nachrichten. Für eine schnellere Bearbeitung senden Sie die vorbereitete E-Mail unten an das MCC.",
    mcc: {
      title: "Das MCC direkt kontaktieren",
      intro: "Das Thailand Privilege Member Contact Center (MCC) bucht diesen Service. Senden Sie ihm diese fertige E-Mail auf Englisch aus Ihrem eigenen Postfach: Wir erhalten eine Kopie und kümmern uns um die Nachverfolgung.",
      titleNext: "Beschleunigen Sie Ihre Anfrage: E-Mail an das MCC",
      recommended: "Empfohlen · schnellere Bearbeitung",
      oneMinute: "Das dauert eine Minute: Die E-Mail ist fertig, Sie müssen sie nur senden.",
      attachReminder: "Ihre Dokumente werden nicht automatisch angehängt (Datenschutz). Bitte hängen Sie sie an Ihre E-Mail an: {{files}}",
      linksIncluded: "Ihre Dokumente sind als sichere Links in der E-Mail enthalten (gültig bis {{date}}). Sie können sie auch anhängen.",
      copyTip: "Tipp: Mit „E-Mail kopieren“ und Einfügen in Ihr Postfach werden die Dateinamen zu anklickbaren Links.",
      emailButton: "E-Mail an das MCC",
      gmailButton: "In Gmail öffnen",
      callButton: "MCC anrufen",
      copyButton: "E-Mail kopieren",
      copied: "E-Mail kopiert.",
      preview: "E-Mail anzeigen",
      hidePreview: "E-Mail ausblenden",
      confirmEmailTitle: "Haben Sie Ihre E-Mail an das MCC gesendet?",
      confirmPhoneTitle: "Haben Sie das MCC erreicht?",
      confirmHint: "Das MCC antwortet in der Regel innerhalb weniger Stunden. Bei dringenden Anliegen senden Sie die E-Mail und rufen Sie zusätzlich {{phone}} an.",
      yes: "Ja",
      notYet: "Noch nicht",
      statusEmail: "Sie haben dem MCC am {{date}} geschrieben.",
      statusPhone: "Sie haben das MCC am {{date}} angerufen.",
      copyReceived: "Wir haben die Kopie Ihrer E-Mail erhalten.",
      followupTitle: "Haben Sie eine Antwort vom MCC erhalten?",
      answered: "Ja, erledigt",
      needHelp: "Nein, ich brauche Hilfe",
      thanks: "Danke, notiert.",
      helpSent: "Wir kümmern uns darum: Unser Team hakt beim MCC für Sie nach.",
      packageTitle: "Ihre Mitgliedschaft: {{package}}",
      privilegePoints: "Privilege-Punkte",
      privilegeBook: "Privilege Book 2026 (PDF)",
      mccLine: "Member Contact Center: {{email}} · {{phone}}",
      done: "Fertig",
    },
    details: {
      whereTitle: "Wo möchten Sie Ihr Visum anbringen lassen?",
      airport: "Am Flughafen, bei der Ankunft",
      airportHint: "Ankunft frühestens 7 Tage nach heute. Halten Sie Ihr Flugticket bereit.",
      chaeng: "Bei der Immigration Chaeng Watthana, Bangkok",
      chaengHint: "Ein Werktag, frühestens 5 Werktage nach heute. Eine TM30-Kopie ist erforderlich.",
      arrivalAirport: "Ankunftsflughafen",
      flightNumber: "Flugnummer",
      departureFrom: "Abflug von",
      departurePlaceholder: "z. B. Frankfurt FRA",
      arrivalDate: "Ankunftsdatum",
      arrivalTime: "Ankunftszeit (Ortszeit)",
      ticket: "Flugticket oder Reiseplan",
      ticketHint: "PDF oder Foto. Wir prüfen, ob es zum obigen Flug passt.",
      ticketChecking: "Ticket wird geprüft…",
      ticketMatch: "Ticket geprüft: Flug und Datum stimmen überein.",
      ticketMismatch: "Bitte prüfen Sie Ihr Ticket:",
      ticketUnreadable: "Wir konnten das Ticket nicht automatisch lesen. Unser Team prüft es.",
      preferredDate: "Wunschdatum",
      period: "Tageszeit",
      morning: "Vormittag (9:00–12:00)",
      afternoon: "Nachmittag (13:00–16:00)",
      alternativeDate: "Zweite Wahl (optional)",
      tentative: "Die Termine sind vorläufig und werden von Member Services je nach Verfügbarkeit bestätigt.",
      tm30: "TM30-Kopie (Adressnachweis)",
      tm30Hint: "Die TM30-Bestätigung Ihres Vermieters oder Hotels.",
      passportCopy: "Reisepasskopie (Fotoseite)",
      passportHint: "Der Reisepass, in den das Visum eingetragen wird. Wenn Sie einen neuen Reisepass haben, laden Sie diesen hoch.",
      passportFromApplication: "Aus Ihrem Antrag",
      useApplicationPassport: "Reisepass aus meinem Antrag verwenden",
      passportNewWarning: "Dies ist nicht der Reisepass, mit dem Sie den Antrag gestellt haben. Bei einem neuen Reisepass muss die Einwanderungsbehörde die Hintergrundprüfung eventuell erneut durchführen, bevor das Visum eingetragen werden kann. Das kann länger dauern. Wir melden uns, falls noch etwas benötigt wird.",
      tm30Guide: "Was ist das TM30?",
      upload: "Hochladen",
      replace: "Ersetzen",
      bank: "Bank",
      bankPlaceholder: "Bank auswählen",
      city: "Stadt",
      branch: "Filiale (optional)",
      branchPlaceholder: "z. B. Silom, Central World",
      bankHint: "Die Bank entscheidet abschließend und kann weitere Unterlagen verlangen.",
      ninetyTitle: "Zur 90-Tage-Meldung",
      ninetySummary: "Mit dem Formular TM47 bestätigen Sie Ihre Adresse alle 90 Tage ununterbrochenen Aufenthalts. Eine Ausreise setzt die Frist zurück. Die Meldung ist von 15 Tagen vor bis 7 Tage nach dem Stichtag möglich; verspätete Meldung kostet 2.000 THB Strafe.",
      readGuide: "Ganzen Ratgeber lesen",
      messageOptional: "Möchten Sie uns noch etwas mitteilen?",
      noMessage: "Siehe Angaben unten.",
      licenseType: "Führerscheinklasse",
      car: "Auto",
      motorcycle: "Motorrad",
      both: "Auto und Motorrad",
      office: "Büro des Department of Land Transport",
      chatuchak: "Chatuchak, Bangkok",
      otherOffice: "Anderes Büro",
      otherOfficePlaceholder: "Stadt / Büro",
      homeLicense: "Ihr gültiger Führerschein aus dem Heimatland",
      residenceCertificate: "Wohnsitzbescheinigung",
      residenceCertificateHint: "Ausgestellt von Ihrer Botschaft (oder eine Arbeitserlaubnis).",
      medicalCertificate: "Ärztliches Attest",
      medicalCertificateHint: "Von einer Klinik in Thailand, nicht älter als einen Monat. Kann auch vor dem Termin besorgt werden.",
      drivingIntro: "An einem Tag beim Department of Land Transport mit unserer Begleitung erledigt. Bringen Sie Ihren Pass mit dem Privilege-Visum mit.",
      drivingGuide: "Ratgeber Führerschein",
      epaService: "Leistung",
      epaArrival: "Ankunft",
      epaDeparture: "Abflug",
      epaAirport: "Flughafen",
      flightDate: "Flugdatum",
      flightTime: "Flugzeit (Ortszeit)",
      originCity: "Abflugort",
      originCityPlaceholder: "z. B. Frankfurt",
      passengers: "Anzahl der Reisenden",
      epaHint: "Der EPA-Service ist von 6:00 bis 24:00 Uhr verfügbar. Buchen Sie mindestens 5 Stunden vor dem Flug.",
      optional: "optional",
      docType: "Dokumentart",
      docTypes: {
        passport: "Reisepass",
        visa_page: "Visumseite",
        photo: "Foto",
        entry_stamp: "Einreisestempel",
        tm30: "TM30",
        flight_ticket: "Flugticket",
        home_license: "Führerschein (Heimatland)",
        residence_certificate: "Wohnsitzbescheinigung",
        medical_certificate: "Ärztliches Attest",
        other: "Anderes Dokument",
      },
      phone: "Telefonnummer (für das MCC)",
      phoneHint: "Aus Ihrem Profil. Sie können sie ändern.",
      fromApplication: "Aus meinem Antrag hinzufügen",
      fromApplicationHint: "Dokumente, die Sie bereits mit Ihrem Antrag hochgeladen haben. Kein erneutes Hochladen nötig.",
      appDocs: {
        passport_photo: "Passfotoseite",
        passport_signature: "Unterschriftenseite des Passes",
        visa: "Visumseite",
        arrival_stamp: "Einreisestempel",
        profile_photo: "Foto",
        marriage_certificate: "Heiratsurkunde",
        birth_certificate: "Geburtsurkunde",
      },
      errors: {
        licenseTypeRequired: "Wählen Sie die Führerscheinklasse.",
        officeRequired: "Wählen Sie das Büro.",
        homeLicenseRequired: "Laden Sie Ihren Führerschein aus dem Heimatland hoch.",
        residenceCertificateRequired: "Laden Sie Ihre Wohnsitzbescheinigung hoch.",
        epaServiceRequired: "Wählen Sie Ankunft oder Abflug.",
        flightDateRequired: "Geben Sie das Flugdatum ein.",
        flightDatePast: "Das Flugdatum liegt in der Vergangenheit.",
        flightTimeRequired: "Geben Sie die Flugzeit ein.",
        epaTooSoon: "EPA muss mindestens 5 Stunden vor dem Flug gebucht werden.",
        originCityRequired: "Geben Sie den Abflugort ein.",
        locationRequired: "Wählen Sie, wo das Visum angebracht werden soll.",
        airportRequired: "Wählen Sie den Ankunftsflughafen.",
        flightNumberInvalid: "Geben Sie die Flugnummer ein, z. B. TG931.",
        arrivalDateRequired: "Geben Sie das Ankunftsdatum ein.",
        arrivalTooSoon: "Die Ankunft muss am {{date}} oder später sein (7 Tage nach heute).",
        arrivalTimeRequired: "Geben Sie die Ankunftszeit ein.",
        preferredDateRequired: "Wählen Sie ein Wunschdatum.",
        weekend: "Die Immigration ist am Wochenende geschlossen. Wählen Sie Montag bis Freitag.",
        appointmentTooSoon: "Wählen Sie den {{date}} oder später (5 Werktage nach heute).",
        periodRequired: "Wählen Sie Vormittag oder Nachmittag.",
        alternativeInvalid: "Die zweite Wahl muss ein Werktag sein, ab dem {{date}}.",
        tm30Required: "Laden Sie eine Kopie Ihres TM30 hoch.",
        passportRequired: "Fügen Sie eine Kopie Ihres Reisepasses bei.",
        bankRequired: "Wählen Sie eine Bank.",
        cityRequired: "Wählen Sie eine Stadt.",
      },
    },
  },

  wizard: {
    applicationSteps: "Antragsschritte",
    step: "Schritt",
    of: "von",
    readOnlyBanner: "Dieser Antrag wurde eingereicht. Wenden Sie sich an den Support, um Änderungen anzufordern.",
    readOnlySupportLink: "Änderung anfordern",
    backgroundCheckTitle: "Antrag in Prüfung",
    backgroundCheckBody: "Ihr Antrag wird derzeit von unserem Team und den zuständigen thailändischen Behörden geprüft. In diesem Stadium kann Ihr Antrag nicht storniert oder geändert werden. Bei Fragen wenden Sie sich bitte an unser Support-Team.",
    backgroundCheckExpected: "Sie erhalten Ihr Genehmigungsschreiben voraussichtlich bis etwa:",
    backgroundCheckNote: "* Dies ist ein geschätzter Zeitrahmen auf Basis einer typischen Bearbeitungszeit von 4–8 Wochen. Er ist nicht garantiert.",
    backgroundCheckContact: "Bei Fragen wenden Sie sich an unser Team:",
    steps: {
      package: "Programm",
      passport: "Reisepass",
      personalInfo: "Persönliche Daten",
      address: "Adresse",
      visa: "Visum & Einreise",
      documents: "Dokumente",
      review: "Überprüfung",
    },
    stepDescriptions: {
      package: "Wählen Sie Ihr Thailand Elite Mitgliedschaftsprogramm",
      passport: "Laden Sie Ihren Reisepass hoch und verifizieren Sie ihn",
      personalInfo: "Vervollständigen Sie Ihre persönlichen Daten",
      address: "Ihre Wohnanschrift und Kontaktdaten",
      visa: "Aktueller Visumstatus und Einreiseinformationen",
      documents: "Erforderliche Dokumente hochladen und unterschreiben",
      review: "Antrag überprüfen und einreichen",
    },
  },

  // ── Next Member ──────────────────────────────────────────────────────────
  nextMember: {
    title: "Angehörigen-Antrag",
    subtitle: "Sie stellen den Antrag als Angehöriger unter einer bestehenden Hauptmitgliedschaft.",
    badge: "Angehöriger",
    addButton: "Angehörigen hinzufügen",
    relationship: "Verwandtschaftsverhältnis zum Hauptmitglied",
    selectRelationship: "Verhältnis auswählen…",
    relationships: {
      spouse: "Ehepartner/in",
      child: "Kind",
      parent: "Elternteil",
      adopted_child: "Adoptivkind",
      civil_union: "Eingetragene/r Lebenspartner/in",
    },
    coreApplication: "Hauptantrag",
    additionalFee: "Gebühr für zusätzliches Mitglied",
    promoLabel: "Aktionspreis",
    regularFee: "Regulärer Preis",
    promoUntil: "Gültig bis 31.12.2026",
    perMember: "/Mitglied",
    existingNextMember: "Angehörigen-Antrag",
  },

  package: {
    title: "Programm wählen",
    subtitle: "Wählen Sie das für Sie am besten geeignete Thailand Elite Mitgliedschaftsprogramm.",
    selected: "Ausgewählt",
    selectPackage: "Programm wählen",
    years: "Jahre",
    perYear: "pro Jahr",
    includes: "Enthält",
    familyOption: "Familienmitglieder möglich",
  },

  passport: {
    title: "Reisepass-Verifizierung",
    subtitle: "Laden Sie die Personalseite Ihres Reisepasses zur OCR-Verifizierung hoch.",
    uploadTitle: "Reisepassfoto hochladen",
    uploadDesc: "Foto oder Scan der Personalseite des Reisepasses (JPG, PNG, PDF — max. 10 MB)",
    uploadHint: "Tippen zum Hochladen oder Foto aufnehmen",
    extractTitle: "Passdaten auslesen",
    extractDesc: "Klicken Sie, um Ihre Daten per KI automatisch auszufüllen — dauert einige Sekunden",
    retakePhoto: "Neu aufnehmen / erneut hochladen",
    passportNumber: "Reisepassnummer",
    surname: "Nachname",
    givenName: "Vorname(n)",
    nationality: "Staatsangehörigkeit",
    dateOfBirth: "Geburtsdatum",
    sex: "Geschlecht",
    dateOfIssue: "Ausstellungsdatum",
    dateOfExpiry: "Ablaufdatum",
    placeOfBirth: "Geburtsort",
    mrz: "Maschinenlesbarer Bereich (MRZ)",
    extractedData: "Extrahierte Daten",
    verifyAndContinue: "Verifizieren & weiter",
    lowConfidenceWarning: "Einige Felder konnten nicht klar gelesen werden. Bitte überprüfen Sie diese vor dem Fortfahren.",
    expiryWarning: "Ihr Reisepass muss für die Bewerbung noch mindestens 6 Monate gültig sein.",
    expiryModalTitle: "Problem mit der Reisepassgültigkeit",
    expiryModalDesc: "Ihr Reisepass muss ab dem Antragsdatum mehr als 1 Jahr gültig sein. Bitte erneuern Sie Ihren Reisepass, bevor Sie sich bewerben.",
    expiryModalCta: "Ich verstehe",
    // Scan requirements
    scanRequirements: "Scan-Anforderungen",
    scanReqColor: "Farbscan — kein Schwarzweiß",
    scanReqEdges: "Alle vier Kanten sichtbar",
    scanReqResolution: "Hohe Auflösung, alle Texte lesbar",
    scanReqFocus: "Nicht unscharf oder verschwommen",
    gallery: "Galerie",
    scanning: "Wird gescannt…",
    uploadDifferentFile: "Andere Datei hochladen",
    fileFormatHint: "JPG, PNG oder PDF · max. 10 MB",
    male: "Männlich",
    female: "Weiblich",
    cityOrTown: "Stadt",
    country: "Land",
    asShownOnPassport: "Wie im Reisepass angegeben",
    ifApplicable: "Falls zutreffend",
    passportUploaded: "Reisepass hochgeladen",
    passportUploadedDesc: "Klicken Sie auf \"Mit KI scannen\", um Ihre Daten zu extrahieren.",
    passportScanned: "Reisepass gescannt ✓",
    passportScannedDesc: "Überprüfen Sie die extrahierten Daten unten.",
    qualityIssuesDetected: "Qualitätsprobleme erkannt",
    scanUnavailable: "Scan nicht verfügbar",
    scanUnavailableDesc: "Bitte geben Sie Ihre Daten manuell ein.",
    applicationAlreadyExists: "Antrag existiert bereits",
    applicationAlreadyExistsDesc: "Ein Antrag für {{name}} wurde bereits gestartet. Bitte setzen Sie ihn fort oder kontaktieren Sie den Support.",
    blurryImage: "Unscharfes Bild",
    reflectionDetected: "Reflexion / Blendung erkannt",
    glareOnPassport: "Blendung auf Reisepass",
    imageCropped: "Bild beschnitten — scannen Sie den vollständigen Reisepass erneut",
    bioPageComplete: "Datenseite vollständig",
    mrzReadable: "MRZ lesbar",
    signaturePage: "Unterschriftsseite",
    signatureOptional: "Optional",
    signaturePageRequired: "Laden Sie die Seite Ihres Reisepasses mit Ihrer handschriftlichen Unterschrift hoch, falls diese nicht auf Ihrer Bio-Seite enthalten ist.",
    signatureDetectedOnBio: "Ihre Unterschrift wurde auf der Datenseite erkannt. Sie können auch die separate Unterschriftsseite hochladen, falls vorhanden.",
    signatureDetectedConfirm: "Unterschrift auf Datenseite erkannt ✓",
    signatureDetectedNote: "Falls Ihr Reisepass eine separate Unterschriftsseite hat (üblich bei deutschen Reisepässen), können Sie sie unten hochladen.",
    signatureNotCorrect: "Nicht korrekt — keine Unterschrift auf dieser Seite",
    noSignatureOnBioPage: "Keine Unterschrift auf Datenseite gefunden",
    noSignatureOnBioPageNote: "Einige Reisepässe enthalten keine Unterschrift auf der Datenseite — laden Sie bitte die Seite mit Ihrer Unterschrift hoch.",
    signaturePageUploaded: "Unterschriftsseite hochgeladen",
    uploadSignaturePageOptional: "Unterschriftsseite hochladen (Optional)",
    uploadSignaturePage: "Unterschriftsseite hochladen",
    replace: "Ersetzen",
    pdf: {
      label: "Reisepass-PDF",
      openPreview: "PDF-Vorschau öffnen",
      detectedNote: "PDF erkannt — die Passseite wird direkt aus dem PDF gelesen.",
    },
    ocrCooldown: "Bitte warten Sie einige Sekunden, bevor Sie es erneut versuchen.",
  },

  personalInfo: {
    title: "Persönliche Daten",
    subtitle: "Überprüfen und vervollständigen Sie Ihr Profil und Ihre Antragsdetails.",
    profilePhoto: {
      title: "Passbild",
      desc: "Ein aktuelles, klares Foto Ihres Gesichts (Passformat). Erforderlich für Ihre Mitgliedskarte.",
      uploadButton: "Foto hochladen",
      changeButton: "Foto ändern",
      takePhoto: "Foto aufnehmen",
      saved: "Gespeichert",
      photoSaved: "Foto gespeichert ✓",
      photoUploadFailed: "Foto-Upload fehlgeschlagen",
      removeBackgroundAi: "Hintergrund mit KI entfernen",
      removeBackgroundNote: "Der Hintergrund wird durch Weiß ersetzt — wird beim nächsten Upload angewendet.",
    },
    identity: {
      sectionTitle: "Identität",
      title: "Titel",
      givenName: "Vorname",
      middleName: "Zweiter Vorname",
      surname: "Nachname",
      nameOnCard: "Name auf der Elite-Karte",
      nameOnCardHint: "Name, der auf Ihrer Mitgliedskarte erscheint",
      dateOfBirth: "Geburtsdatum",
      gender: "Geschlecht",
      occupation: "Beruf",
      businessIndustry: "Branche",
    },
    applicationDetails: {
      sectionTitle: "Antragsdetails",
      sectionDesc: "Aus Ihrem Reisepass-Scan vorausgefüllt. Reisepassdaten werden automatisch übernommen.",
      fromPassport: "Aus dem Reisepass",
      nationality: "Staatsangehörigkeit",
      placeOfBirth: "Geburtsort",
      countryOfBirth: "Geburtsland",
    },
    nationalityCheck: {
      question: "Besitzen Sie derzeit eine weitere Staatsangehörigkeit?",
      otherNationality: "Weitere Staatsangehörigkeit",
      passportsIntro: "Geben Sie jeden weiteren Reisepass und jede weitere Staatsangehörigkeit an. Diese Angaben erscheinen auf der Erklärung über mehrere Reisepässe und Staatsangehörigkeiten (Seite 2 Ihres Antragsformulars), die Sie unterschreiben.",
      passportHeading: "Weiterer Reisepass {{n}}",
      passportNumber: "Reisepassnummer",
      issueDate: "Ausstellungsdatum",
      expiryDate: "Ablaufdatum",
      nameOnPassport: "Vollständiger Name in diesem Pass (falls abweichend)",
      addPassport: "Weiteren Reisepass hinzufügen",
      passportRequired: "Bitte geben Sie Staatsangehörigkeit und Nummer Ihres weiteren Reisepasses an.",
      requiredDocsTitle: "Erforderliche Unterlagen bei mehreren Staatsangehörigkeiten:",
      reqDoc1: "Reisepass/-pässe Ihrer ursprünglichen Staatsangehörigkeit sowie frühere Pässe, falls sich Ihr Vor- oder Nachname geändert hat.",
      reqDoc2: "Amtliche Dokumente über den Verzicht auf Ihre ursprüngliche Staatsangehörigkeit (falls zutreffend).",
      reqDoc3: "Nachweise über Ihr Einkommen und die Herkunft der Mittel für die Mitgliedschaft.",
      reqDoc4: "Nachweis des ständigen Wohnsitzes in Thailand oder im Ausland für die letzten 6 Monate.",
      mismatchTitle: "Geburtsland weicht von Ihrer Staatsangehörigkeit ab",
      mismatchIntro: "Uns ist außerdem aufgefallen, dass Ihr Geburtsland von Ihrem Staatsangehörigkeitsland abweicht, obwohl Sie angegeben haben, nur eine Staatsangehörigkeit zu besitzen.",
      mismatchBody: "Bitte beachten Sie, dass die Einwanderungsbehörden strenge Anforderungen an die Visumerteilung stellen und zusätzliche Unterlagen anfordern können. Wenn Sie eine doppelte Staatsangehörigkeit besitzen, müssen Sie diese angeben. Wenn Sie auf eine frühere Staatsangehörigkeit verzichtet haben, halten Sie bitte die entsprechenden Nachweise bereit.",
      listTitle: "Falls zutreffend, reichen Sie bitte ein:",
      doc1: "Eine gut lesbare Kopie Ihres zweiten Reisepasses.",
      doc2: "Eine Kopie Ihrer Einbürgerungsurkunde oder eines anderen Nachweises, wie Sie Ihre aktuelle Staatsangehörigkeit erworben haben, zusammen mit einer kurzen Erläuterung.",
      doc3: "Eine Kopie Ihrer Verzichtsurkunde, falls Sie früher eine andere Staatsangehörigkeit besaßen und darauf verzichtet haben.",
      explanationLabel: "Kurze Erläuterung (optional)",
      explanationPlaceholder: "z. B. In Brasilien geboren, 2010 in Deutschland eingebürgert, brasilianische Staatsangehörigkeit 2012 aufgegeben.",
      uploadTitle: "Nachweise",
      uploadDesc: "PDF, JPG oder PNG — max. 10 MB pro Datei.",
    },
    contact: {
      phone: "Telefon",
      phonePlaceholder: "+66 XX XXX XXXX",
      email: "E-Mail-Adresse",
      emailHint: "Für Ihren Antrag verwendet. Kann von Ihrer Anmelde-E-Mail abweichen.",
    },
    sharedProfile: "Gemeinsames Profil",
    fillAllRequiredFields: "Bitte füllen Sie alle Pflichtfelder aus",
  },

  address: {
    title: "Adresse",
    subtitle: "Ihre aktuelle Wohnanschrift.",
    currentAddress: "Aktuelle Adresse",
    street: "Straße und Hausnummer",
    streetHint: "OpenStreetMap-Autovervollständigung",
    startTyping: "Adresse eingeben…",
    city: "Stadt",
    state: "Bundesland / Provinz",
    country: "Land",
    postalCode: "Postleitzahl",
    thaiAddress: "Thailand-Adresse",
    haveThaiAddress: "Ich habe eine Adresse in Thailand",
    accommodationType: "Unterkunftstyp",
    province: "Provinz",
    district: "Bezirk",
    subDistrict: "Unterbezirk",
    thaiTelephone: "Telefon (Thailand)",
    thaiPhoneNote: "Thailändische Telefonnummer (ohne führende 0)",
    validationError: "Bitte geben Sie Straße, Stadt und Land an",
  },

  visa: {
    title: "Visum & Einreisestatus",
    subtitle: "Ihr aktuelles thailändisches Visum und Ihre Einreisedaten.",
    currentVisa: "Aktuelles thailändisches Visum",
    hasThaiVisa: "Besitzen Sie derzeit ein thailändisches Visum?",
    visaType: "Visumtyp",
    visaExpiry: "Ablaufdatum des Visums",
    uploadVisaPage: "Foto der Visumseite",
    uploadVisaBtn: "Visumseite hochladen",
    arrivalStamp: "Einreisestempel",
    hasArrivalStamp: "Besitzen Sie derzeit einen Einreisestempel?",
    stampExpiry: "Ablaufdatum des Einreisestempels",
    uploadStampPage: "Foto der Stempelseite",
    uploadStampBtn: "Stempelseite hochladen",
    passportStatus: "Reisepassstatus",
    blankVisaPages: "Mehr als 3 leere Visumseiten in Ihrem Reisepass?",
    blankYes: "Ja — mehr als 3",
    blankNo: "Nein — 3 oder weniger",
    overstayCount: "Überschreitungen der Aufenthaltsgenehmigung in Thailand (letzte 3 Jahre)",
    overstayNever: "0 — Nie",
    otherVisaOption: "Sonstiges (bitte angeben)",
    otherVisaLabel: "Bitte geben Sie Ihr Visum an",
    otherVisaPlaceholder: "Kurzcode, z. B. Non-O, SMART-T",
    edVisa: {
      sectionTitle: "Bildungsvisum (ED) Verlauf",
      sectionDesc: "Erforderliche Angabe für die Thailand Elite Eignungsprüfung.",
      question: "Haben Sie in den letzten 5 Jahren oder in Ihrem aktuellen Reisepass ein Bildungsvisum (ED) gehabt?",
      warningTitle: "Zusätzliche Nachweisdokumente erforderlich",
      warningDesc: "Die Akzeptanz von Antragstellern mit Bildungsvisum-Geschichte hängt von der Einreichung der folgenden Dokumente ab. Fehlende Dokumente können zur Ablehnung führen.",
      doc1: "Schulzulassungslizenz (สช.2 / OBEC / OPEC)",
      doc2: "Schulregistrierung (ร.2)",
      doc3: "Schülerbestätigung der Schule",
      doc4: "Zeugnisse, Notenberichte und Anwesenheitsaufzeichnungen",
      doc5: "Fotos von Unterrichtsaktivitäten",
      doc5Optional: "(optional — später hochladen, wenn nicht verfügbar)",
      acknowledgementForm: "Bestätigungsformular",
      acknowledgementFormDesc: "Herunterladen, ausfüllen und mit Ihren Nachweisdokumenten hochladen",
      uploadTitle: "Nachweisdokumente hochladen",
      uploadDesc: "PDF, JPG oder PNG — Sie können mehrere Dateien hochladen. Sicher in Ihrem Antrag gespeichert.",
    },
  },

  visaReminder: {
    title: "Wichtig — Halten Sie ein gültiges Visum aufrecht",
    body: "Bitte sorgen Sie jederzeit für ein gültiges Visum, wenn Sie sich in Thailand aufhalten. Die Einreichung dieses Antrags gewährt Ihnen keine Verlängerung des Aufenthalts und keine Erlaubnis, in Thailand zu bleiben. Wenn Sie sich derzeit in Thailand befinden, stellen Sie bitte sicher, dass Ihr Visum während des gesamten Antragsverfahrens gültig bleibt.",
  },

  documents: {
    title: "Dokumente",
    subtitle: "Laden Sie Ihre Antragsformulare herunter, unterschreiben und laden Sie diese hoch.",
    applicationForm: {
      title: "Antragsformular",
      desc: "Laden Sie Ihr vorausgefülltes Antragsformular herunter, unterschreiben Sie es digital und laden Sie es hoch.",
      download: "Vorausgefülltes PDF herunterladen",
      signDigitally: "Digital unterschreiben",
      signatureCapture: "Unterschrift erfassen",
      signatureCaptureDesc: "Zeichnen Sie Ihre Unterschrift unten",
      clear: "Löschen",
      save: "Unterschrift speichern",
      appliedTo: "Auf alle Seiten angewendet",
      uploadSigned: "Unterschriebenes Formular hochladen",
    },
    pdpaForm: {
      title: "PDPA-Einwilligungsformular",
      desc: "Einwilligung zum Datenschutzgesetz. Herunterladen, unterschreiben und hochladen.",
      download: "PDPA-Formular herunterladen",
      signDigitally: "Digital unterschreiben",
      uploadSigned: "Unterschriebenes Formular hochladen",
    },
    uploadStatus: "Upload-Status",
    viewDocument: "Hochgeladenes Dokument anzeigen",
    downloadDocument: "Unterschriebenes PDF herunterladen",
    signingComplete: "Unterschrift abgeschlossen — zum Speichern hochladen",
    remaining: "verbleibend",
    requiredDocuments: "Erforderliche Dokumente",
    continueToReview: "Weiter zur Überprüfung",
    blankForm: "Leeres Formular",
    blankAddendum: "Leerer Aktionsnachtrag",
    downloadLabel: "Herunterladen",
    reprefill: "Neu ausfüllen",
    // Toast messages for DocumentsStep
    applicationFormPrefilled: "Antragsformular vorausgefüllt",
    applicationFormPrefilledDesc: "Heruntergeladen! Unterschreiben Sie jede Seite, dann hochladen oder digital unterschreiben.",
    prefillFailed: "Vorausfüllen fehlgeschlagen",
    applicationFormSigned: "Antragsformular unterschrieben und gespeichert ✓",
    signingFailed: "Unterschrift fehlgeschlagen",
    applicationFormUploaded: "Antragsformular hochgeladen ✓",
    pdpaFormSigned: "PDPA-Einwilligungsformular unterschrieben und gespeichert ✓",
    pdpaFormUploaded: "PDPA-Einwilligungsformular hochgeladen ✓",
    documentUploaded: "Dokument hochgeladen ✓",
    uploaded: "Hochgeladen ✓",
    translationUploaded: "Übersetzung hochgeladen ✓",
    uploadTranslation: "Übersetzung hochladen",
    relationshipProof: {
      title: "Nachweisdokumente zum Verwandtschaftsverhältnis",
      subtitle: "Laden Sie offizielle Dokumente hoch, die Ihr Verwandtschaftsverhältnis zum Hauptmitglied belegen.",
      marriageCert: "Heiratsurkunde",
      birthCert: "Geburtsurkunde",
      adoptionCert: "Adoptionsurkunde",
      civilUnionCert: "Lebenspartnerschaftsurkunde",
      notInEnglish: "Dieses Dokument ist nicht auf Englisch",
      certifiedTranslation: "Beglaubigte englische Übersetzung",
    },
    signatureCapture: {
      title: "E-Signatur (Optional)",
      subtitle: "Zeichnen oder laden Sie Ihre Unterschrift hoch, um sie auf alle Antragsdokumente anzuwenden.",
      saved: "Unterschrift gespeichert",
      willBeApplied: "Wird auf alle Dokumente angewendet",
      confirm: "Ich verstehe und möchte digital unterschreiben",
      disclaimer1: "Der Antragsteller muss alle Seiten des Antrags persönlich unterschreiben. Ist der Antragsteller unter 20 Jahre alt, muss auch der gesetzliche Vertreter unterschreiben.",
      disclaimer2: "Alle Unterschriften müssen exakt mit der Unterschrift im Reisepass übereinstimmen.",
      disclaimer3: "⚠️ Wir erlauben digitale Unterschriften, beachten Sie jedoch, dass die Thailand Privilege Card in einigen Fällen eine vollständig gedruckte, handschriftlich unterschriebene und gescannte Kopie aller Seiten anfordern kann. Wenn Sie über einen Drucker und Scanner verfügen, empfehlen wir dringend, von Hand zu drucken und zu unterschreiben.",
      options: {
        upload: {
          title: "Unterschrift hochladen",
          desc: "Laden Sie ein Bild Ihrer Unterschrift hoch",
          instruction: "Klicken Sie hier oder ziehen Sie eine Bilddatei hierher",
          enhancing: "Wird optimiert…",
          clickToUpload: "Zum Hochladen klicken",
        },
        passport: {
          title: "Reisepass-Unterschrift verwenden",
          desc: "Extrahieren Sie Ihre Unterschrift aus Ihrem hochgeladenen Reisepass-Scan",
          passportRef: "Reisepass-Scan",
          notFound: "Kein Reisepass-Scan gefunden — bitte laden Sie zuerst Ihren Reisepass hoch",
          instruction: "Klicken Sie, um die Unterschrift aus dem Reisepass zu extrahieren",
          uploadBtn: "Aus Reisepass extrahieren",
        },
        draw: {
          title: "Unterschrift zeichnen",
          desc: "Zeichnen Sie Ihre Unterschrift mit der Maus oder dem Finger",
        },
      },
    },
  },

  review: {
    title: "Überprüfung & Einreichung",
    subtitle: "Überprüfen Sie Ihren Antrag vor der Einreichung.",
    applicationSummary: "Antragsübersicht",
    membershipPackage: "Mitgliedschaftsprogramm",
    fullName: "Vollständiger Name",
    nationality: "Staatsangehörigkeit",
    dateOfBirth: "Geburtsdatum",
    passportNo: "Reisepassnr.",
    passportExpiry: "Reisepassablauf",
    occupation: "Beruf",
    country: "Land",
    city: "Stadt",
    phone: "Telefon",
    email: "E-Mail",
    remaining: "verbleibend",
    requiredDocuments: "Erforderliche Dokumente",
    passportPhoto: "Reisepass / Ausweis-Foto",
    profilePhoto: "Profilfoto",
    applicationFormSigned: "Antragsformular (unterschrieben)",
    pdpaFormSigned: "PDPA-Einwilligungsformular (unterschrieben)",
    missingDocsWarning: "Bitte vervollständigen Sie alle erforderlichen Dokumente in Schritt 6 vor der Einreichung.",
    // Validation issues
    validation: {
      fullNameMissing: "Vollständiger Name fehlt",
      passportNoMissing: "Reisepassnummer fehlt",
      passportExpiryMissing: "Ablaufdatum des Reisepasses fehlt",
      passportValidityWarning: "Die Reisepassgültigkeit muss ab dem Antragsdatum mehr als 1 Jahr betragen",
      nationalityMissing: "Staatsangehörigkeit fehlt",
      otherNationalityMissing: "Frage zur weiteren Staatsangehörigkeit nicht beantwortet",
      phoneMissing: "Telefonnummer fehlt",
      countryMissing: "Wohnsitzland fehlt",
      cityMissing: "Stadt fehlt",
      missingInfoTitle: "Fehlende Angaben — bitte vor der Einreichung vervollständigen",
      goTo: "Gehe zu",
      completeBeforeSubmitting: "Bitte vervollständigen Sie die oben fehlenden Angaben vor der Einreichung",
      accountFlaggedTitle: "Ihr Konto wurde markiert",
      uploadFlagged: "Einer Ihrer Uploads entspricht nicht unseren Dokumentenregeln, daher wurde Ihr Konto zur Prüfung markiert. Falls es sich um einen Irrtum handelt, senden Sie uns eine Nachricht – unser Team prüft das.",
      contactUs: "Nachricht senden",
      passportNotGenuine: "Die hochgeladene Datei ist keine lesbare Passdatenseite (die Seite mit Ihrem Foto und den zwei Codezeilen unten). Bitte laden Sie eine klare Kopie Ihres echten Reisepasses hoch.",
      passportDataMismatch: "Einige Angaben stimmen nicht mit Ihrem gescannten Reisepass überein: {{fields}}. Bitte korrigieren Sie sie, damit sie genau Ihrem Reisepass entsprechen.",
      mismatchConfirm: "Meine Angaben sind korrekt – bitte lassen Sie das Team meinen Reisepass prüfen",
      fieldPassportNo: "Passnummer",
      fieldDob: "Geburtsdatum",
      fieldExpiry: "Ablaufdatum des Reisepasses",
    },
    survey: {
      title: "Umfrage",
      howDidYouLearn: "Wie haben Sie von Thailand Elite erfahren?",
      mainReason: "Hauptgrund für Ihre Bewerbung?",
      expectation: "Was erwarten Sie von der Mitgliedschaft?",
    },
    agreement: "Ich bestätige, dass alle angegebenen Informationen korrekt, vollständig und authentisch sind. Ich stimme der Verarbeitung meiner persönlichen Daten und Dokumente — einschließlich KI-gestützter Reisepass-OCR und Unterschriftsverifizierung — durch Dreamond und Thailand Privilege Card Co., Ltd. zum Zweck meiner Mitgliedschaftsbewerbung zu. Ich verstehe, dass bis zur offiziellen Genehmigung meines Antrags keine Zahlung erforderlich ist und dass etwaige Zahlungen ausschließlich an Thailand Privilege Card Co., Ltd. auf Basis ihrer offiziellen Rechnung zu leisten sind. Ich habe die",
    termsAndConditions: "Allgemeinen Geschäftsbedingungen",
    and: "und die",
    privacyPolicy: "Datenschutzrichtlinie",
    noPaymentNote: "keine Zahlung bis zur offiziellen Genehmigung erforderlich",
    missingDocumentsError: "Fehlende Dokumente",
    missingDocumentsErrorDesc: "Bitte laden Sie alle erforderlichen Dokumente vor der Einreichung hoch.",
    submittedTitle: "Antrag eingereicht!",
    submittedDesc: "Wir werden Ihren Antrag prüfen und uns bei Ihnen melden.",
    submissionFailed: "Einreichung fehlgeschlagen",
  },

  // ── Post-Approval Screens ─────────────────────────────────────────────────
  screens: {
    common: {
      contactSupport: "Bei Fragen wenden Sie sich an unser Team:",
    },
    approved: {
      title: "Herzlichen Glückwunsch! Ihr Antrag wurde genehmigt",
      message: "Bitte prüfen Sie Ihre E-Mails auf das Genehmigungsschreiben und die Rechnung. Sie müssen die Zahlung innerhalb von 30 Tagen abschließen, um Ihre Mitgliedschaft zu aktivieren.",
      uploadTitle: "Zahlungsnachweis hochladen",
      uploadHint: "Überweisungsbeleg, Screenshot oder PDF (max. 10 MB)",
      uploadButton: "Zahlungsnachweis hochladen",
      uploadSuccess: "Zahlungsnachweis hochgeladen",
      uploadSuccessDesc: "Die Finanzabteilung prüft Ihre Zahlung in der Regel innerhalb von etwa 3 Werktagen.",
      uploadedConfirmation: "Zahlungsnachweis hochgeladen — in Prüfung",
      cardPaymentTitle: "Mit Kreditkarte bezahlen",
      cardPaymentHint: "Fordern Sie einen sicheren Zahlungslink bei der Finanzabteilung an",
      requestLink: "Kreditkarten-Zahlungslink anfordern",
      payByCard: "Mit Kreditkarte bezahlen",
      linkRequested: "Anfrage gesendet",
      linkRequestedDesc: "Die Finanzabteilung sendet Ihnen in Kürze einen Zahlungslink.",
      note: "Wenn Sie Ihren Zahlungsnachweis bereits hochgeladen haben, ist keine weitere Aktion erforderlich.",
      proofRejectedTitle: "Wir konnten Ihren Zahlungsnachweis nicht bestätigen",
      proofRejectedHelp: "Bitte laden Sie unten einen neuen Zahlungsnachweis hoch. Bei Fragen antworten Sie auf unsere E-Mail oder kontaktieren Sie uns.",
    },
    paymentPending: {
      title: "Zahlung in Prüfung",
      message: "Ihr Zahlungsnachweis ist eingegangen und wurde zur Prüfung an die Finanzabteilung weitergeleitet. Die Prüfung dauert in der Regel etwa 3 Werktage, danach etwa 4 Werktage für die Aktivierung Ihrer Mitgliedschaft und das Willkommensschreiben.",
      verifying: "Zahlung wird überprüft…",
      uploaded: "Hochgeladen",
      expected: "Voraussichtliche Prüfung",
      uploadDate: "Upload-Datum",
      expectedDate: "Voraussichtlich bis",
      activationDate: "Aktivierung etwa am",
      note: "Dies sind übliche Zeiten (insgesamt etwa 7 Werktage). Sie können je nach Zahlungseingang und Auslastung der Finanzabteilung variieren.",
      verifiedTitle: "Zahlung geprüft",
      verifiedMessage: "Ihre Zahlung wurde geprüft. Ihre Mitgliedschaft wird jetzt ausgestellt: Das Willkommensschreiben folgt in der Regel innerhalb von etwa 4 Werktagen.",
      addTitle: "Weiteren Zahlungsnachweis hinzufügen",
      addHint: "Wenn die Finanzabteilung weitere Unterlagen anfordert oder Sie einen Kontoauszug, eine Belastungsanzeige oder eine SWIFT-MT103 haben, fügen Sie sie hier hinzu. Alle Unterlagen werden für die Prüfung zusammengeführt.",
      addButton: "Dokument hinzufügen",
      added: "Dokument hinzugefügt",
      documentsTitle: "Gesendete Dokumente",
    },
    paymentDone: {
      title: "Zahlung bestätigt",
      message: "Ihre Zahlung wurde von der Finanzabteilung bestätigt. Sie erhalten in Kürze Ihr Willkommensschreiben und die Informationen zu Ihrer Mitgliedskarte per E-Mail.",
      verified: "Zahlung bestätigt ✓",
      nextStepsTitle: "Wie geht es weiter?",
      step1: "Sie erhalten Ihr Willkommensschreiben per E-Mail",
      step2: "Ihre Mitgliedskarte wird vorbereitet",
      step3: "Wir kontaktieren Sie für den Termin zur Visa-Anbringung",
      package: "Ihre Mitgliedschaft",
    },
    prePayment: {
      title: "Wichtiger Hinweis vor der Zahlung",
      intro: "Leisten Sie bitte keine Zahlung, wenn einer der folgenden Punkte auf Sie zutrifft.",
      conditions: [
        {
          title: "Gültigkeit des Einreisestempels",
          detail: "Die im Einreisestempel Ihres Passes ausgewiesene Aufenthaltserlaubnis muss gültig sein. Wer während des laufenden Aufenthalts einen Overstay verzeichnet hat, kann unter keinen Umständen ein Thailand-Privilege-Visum erhalten.",
        },
        {
          title: "Non-Immigrant-O-Visum (Volunteer)",
          detail: "Wer derzeit ein Non-Immigrant-Visum des Typs O (Volunteer) besitzt oder zu irgendeinem Zeitpunkt besessen hat, kann unter keinen Umständen ein Thailand-Privilege-Visum erhalten.",
        },
        {
          title: "Non-Immigrant-MT- oder -ED-Visum",
          detail: "Wer derzeit ein Non-Immigrant-MT-Visum (medizinische Behandlung) ohne den erforderlichen Patientenbericht des Krankenhauses oder ein ärztliches Attest besitzt, oder ein Non-Immigrant-ED-Visum (Ausbildung) ohne das offizielle Dokument der Office of Basic Education Commission (OBEC) samt zugehörigen Nachweisen, kann unter keinen Umständen ein Thailand-Privilege-Visum erhalten.",
        },
      ],
      warning: "Trifft einer der genannten Punkte zu, behält sich Thailand Privilege Card Co., Ltd. das Recht vor, die Mitgliedsgebühr ohne Erstattung einzubehalten.",
      rulesTitle: "Zahlungsbedingungen",
      rules: [
        { text: "Die Mitgliedsgebühr ist in einer einzigen Transaktion zu überweisen, in Übereinstimmung mit dem Anti-Money Laundering Act, B.E. 2542 (1999) und seinen Änderungen. Auch eine Überweisung per Mobile Banking muss dem vollen Betrag in einer einzigen Transaktion entsprechen." },
        { text: "Der bei Thailand Privilege Card Co., Ltd. eingehende Betrag muss der vollständigen Mitgliedsgebühr entsprechen. Sämtliche Bankgebühren, Gebühren zwischengeschalteter Banken, Agenturgebühren und sonstige in- oder ausländische Überweisungskosten tragen Sie zusätzlich." },
        { text: "Das Genehmigungsschreiben und die Rechnung sind ab Ausstellungsdatum 30 Tage gültig. Ein abgelaufener Antrag unterliegt einer erneuten Sicherheitsüberprüfung." },
        { text: "Zahlungen nach dem auf der Rechnung genannten Fälligkeitsdatum werden nicht angenommen und sind von Aktionsangeboten ausgeschlossen." },
        { text: "American-Express-Karten werden nicht akzeptiert." },
      ],
      doubt: "Wenn Sie unsicher sind, ob einer dieser Punkte auf Sie zutrifft, wenden Sie sich vor der Zahlung an uns. Wir prüfen Ihre Unterlagen vorab.",
    },

    visaAffix: {
      title: "Visa-Anbringung beantragen",
      intro: "Senden Sie die Anfrage an unser Team. Wir fügen die bereits in Ihrer Akte vorliegenden Dokumente bei, leiten sie an das Member Contact Center weiter und verfolgen die Terminvergabe.",
      locationLabel: "Gewünschter Ort der Anbringung",
      locations: {
        chaengWattana: "Immigration Office Chaeng Wattana, Bangkok",
        suvarnabhumi: "Flughafen Suvarnabhumi, bei Ankunft",
        phuket: "Internationaler Flughafen Phuket, bei Ankunft",
        chiangMai: "Internationaler Flughafen Chiang Mai, bei Ankunft",
        overseas: "Außerhalb Thailands (e-Visa über eine thailändische Auslandsvertretung)",
      },
      noticeThailand: "Termine erfordern eine Vorlaufzeit von 5 bis 7 Werktagen und hängen von der Verfügbarkeit eines Elite Personal Liaison ab.",
      noticeOverseas: "Ein e-Visa wird über das offizielle Portal der thailändischen Regierung ausgestellt. Rechnen Sie mit 15 bis 30 Werktagen ab Einreichung.",
      dateLabel: "Wunschtermin",
      flightLabel: "Ankunftsflug",
      flightPlaceholder: "z. B. TG911, 14. Okt.",
      documentsLabel: "Dokumente in Ihrer Akte",
      documentsHint: "Wählen Sie aus, was wir beifügen sollen. Standardmäßig ist alles ausgewählt.",
      documentTypes: {
        passport_photo: "Reisepass",
        application_form: "Antragsformular",
        consent_form: "Einwilligungserklärung",
        payment_proof: "Zahlungsnachweis",
      },
      submit: "Anfrage verfassen",
      mccTitle: "Member Contact Center",
      mccHint: "Wenn Sie den Termin selbst vereinbaren möchten, wenden Sie sich direkt an das MCC und geben Sie Ihre Mitgliedsnummer an.",
      email: {
        subject: "Antrag auf Visa-Anbringung",
        intro: "Ich möchte einen Termin für die Anbringung des Privilege Entry Visums beantragen.",
        member: "Mitglied",
        card: "Mitgliedsnummer",
        package: "Programm",
        location: "Gewünschter Ort",
        preferredDate: "Wunschtermin",
        flight: "Ankunftsflug",
        documentsHeld: "Bitte aus meiner Akte beifügen",
        noneSelected: "Keine Dokumente ausgewählt",
        notSpecified: "Nicht angegeben",
        closing: "Vielen Dank.",
      },
    },

    active: {
      title: "Willkommen bei Thailand Elite!",
      subtitle: "Herzlichen Glückwunsch — Sie sind jetzt offizielles Thailand Elite Mitglied.",
      cardNo: "Mitgliedsnr.",
      package: "Programm",
      validFrom: "Gültig ab",
      validUntil: "Gültig bis",
      requestVisaAffix: "Visa-Anbringung anfordern",
      memberArea: "Mitglieder-Dashboard",
    },
    rejected: {
      title: "Antrag nicht genehmigt",
      titleCancelled: "Antrag storniert",
      message: "Leider konnte Ihr Antrag derzeit nicht genehmigt werden. Wenn Sie Fragen zu dieser Entscheidung haben, wenden Sie sich bitte an unser Support-Team.",
      messageCancelled: "Dieser Antrag wurde storniert. Wenn Sie sich erneut bewerben möchten, können Sie einen neuen Antrag starten.",
      messageInactive: "Dieser Antrag wurde nach längerer Inaktivität geschlossen. Alle Ihre Angaben sind gespeichert – Sie können dort weitermachen, wo Sie aufgehört haben.",
      resume: "Antrag fortsetzen",
      resumedToast: "Willkommen zurück! Ihr Antrag ist wieder geöffnet.",
      resumeFailed: "Der Antrag konnte nicht wieder geöffnet werden. Bitte senden Sie uns eine Nachricht.",
      info: "Sie können einen neuen Antrag starten, wenn Sie sich erneut bewerben möchten.",
      startNew: "Neuen Antrag starten",
    },
  },

  auth: {
    login: {
      title: "Mitgliederportal",
      subtitle: "Melden Sie sich in Ihrem Konto an",
      email: "E-Mail",
      continueWithEmail: "Mit E-Mail fortfahren",
      sendingLink: "Link wird gesendet…",
      noPasswordNote: "Wir senden Ihnen einen sicheren Anmelde-Link – kein Passwort erforderlich.",
      noAccount: "Sie haben noch kein Konto?",
      createOne: "Eines erstellen",
      checkEmailTitle: "E-Mail prüfen",
      checkEmailDesc: "Wir haben einen Anmelde-Link an <strong>{{email}}</strong> gesendet. Klicken Sie auf den Link, um auf Ihr Konto zuzugreifen.",
      didntReceive: "Nicht erhalten?",
      tryAgain: "Erneut versuchen",
      accountDisabledTitle: "Konto deaktiviert",
      accountDisabledMsg: "Ihr Konto wurde deaktiviert.",
      accountDisabledReason: "Grund:",
      accountDisabledContact: "Wenn Sie glauben, dass dies ein Fehler ist, kontaktieren Sie uns bitte unter",
    },
    register: {
      title: "Konto erstellen",
      subtitle: "Beginnen Sie Ihre Thailand Elite Reise",
      firstName: "Vorname",
      lastName: "Nachname",
      email: "E-Mail",
      phoneNumber: "Telefonnummer",
      searchCountry: "Land suchen…",
      continueWithEmail: "Mit E-Mail fortfahren",
      sendingLink: "Magic-Link wird gesendet…",
      noPasswordNote: "Wir senden Ihnen einen sicheren Link zur Bestätigung Ihrer E-Mail und Anmeldung – kein Passwort erforderlich.",
      alreadyHaveAccount: "Sie haben bereits ein Konto?",
      signIn: "Anmelden",
      checkEmailTitle: "E-Mail prüfen",
      checkEmailDesc: "Wir haben einen Magic-Link an <strong>{{email}}</strong> gesendet. Klicken Sie auf den Link in Ihrer E-Mail, um sich anzumelden und Ihre Registrierung abzuschließen.",
      didntReceive: "Nicht erhalten?",
      tryAgain: "Erneut versuchen",
    },
  },
};
